import { cellComponents } from "@portal/BaseComponents/Table/Components/cellComponents";
import { TableWrapper } from "@portal/BaseComponents/Table/Components/style";
import { defaultColumnDefs } from "@portal/BaseComponents/Table/default";
import { Formats } from "@portal/hooks/use-formats";
import { usePaymentListQuery } from "@portal/queries/payment-query";
import { paymentFiltersAtom } from "@portal/store/Filters/payments/payments-filter";
import { tableAtom } from "@portal/store/table/table";
import { PaymentList } from "@portal/types/entities/payment";
import { Sorter, Table } from "@sinecycle/growcomponents";
import produce from "immer";
import { useAtom } from "jotai";
import { useColumns } from "./Columns/useColumns";

interface PaymentListTableProps {
  extra: Formats;
}
function PaymentListTable(props: PaymentListTableProps) {
  const [tableValue, setTable] = useAtom(tableAtom);
  const [paymentFilters, setPaymentFilters] = useAtom(paymentFiltersAtom);
  const { data, isLoading } = usePaymentListQuery({
    page: tableValue.currentPage,
    size: 10,
    filters: {
      ...paymentFilters.sorting,
      ...paymentFilters.filterValues,
    },
  });
  const { defaultColConfigs } = useColumns(props.extra);
  function handleSort(sortParams: Sorter) {
    setPaymentFilters((filter) => {
      return produce(filter, (draft) => {
        draft.sorting = {
          order: sortParams.sortOrder,
          sort_col: sortParams.sortCol,
        };
      });
    });
  }

  return (
    <TableWrapper>
      <Table<PaymentList>
        loading={isLoading}
        gridProps={{
          rowData: data?.list,
          columnDefs: defaultColConfigs,
          defaultColDef: {
            ...defaultColumnDefs,
            autoHeight: false,
            sortable: false,
            flex: 1,
          },
          animateRows: true,
          suppressMovableColumns: true,
          components: cellComponents,
          unSortIcon: true,
          enableCellTextSelection: true,
        }}
        tableState={tableValue}
        handlePageChange={(page) => {
          setTable((value) => {
            return produce(value, (draft) => {
              draft.currentPage = page;
              return draft;
            });
          });
        }}
        sortMode={{
          type: "remote",
          onSortChange: handleSort,
        }}
        enableColumnCustom={{
          type: "header-only",
          content: {
            preserve: {
              type: "LOCAL",
              storageKey: "PAYMENTS_PORTAL",
            },
          },
        }}
      />
    </TableWrapper>
  );
}

export { PaymentListTable as PaymentList };
